import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Role } from "../../../domain/entities/user";
import { type UsersDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listRoles = createAsyncThunk<
  Role[],
  void,
  { dispatch: UsersDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_ROLES, async (_, { extra }) => {
  return await extra.usersRepo.listRoles();
});
